/* ═══ MIRIAM LLANTADA · FICHA DE FORMACIÓN · MÓDULO DE PESTAÑAS ═══
   Sin dependencias ni librerías, compatible con defer. Se inicia por
   instancia, igual que ml-producto.js y ml-producto-curso.js, para que el
   editor de temas pueda cargar y descargar la sección sin recargar.
   Expone window.MLPestanas.init(root) y .destroy(root).

   Viene de ../../familias/f1-formacion-A1-v7.html, la maqueta aprobada.

   Un solo estado —cuál está activo— sirve para los dos modos. En
   escritorio manda el tablist y los paneles que no tocan llevan hidden; por
   debajo de 760 px el tablist desaparece y cada panel abre y cierra con su
   propia cabecera. No se hace scroll vertical al cambiar: quien lee se
   queda donde estaba.

   El reparto de anchos de la fila lo resuelve el CSS —columnas
   minmax(max-content,1fr)—, así que el guion solo se ocupa de tres cosas:

     bordes()  mira si hay desbordamiento y si queda algo a cada lado, y con
               eso enciende el desvanecido de cada extremo, muestra las
               flechas y las desactiva al llegar al final. Si todo cabe, no
               hay ni flechas ni desvanecido.
     ver(i)    trae la pestaña elegida a la vista con scrollIntoView e
               inline nearest, y block nearest para no mover la página en
               vertical. Se llama al elegir con el ratón, al recorrer con el
               teclado y cuando una pestaña recibe el foco con el tabulador.
     paso(d)   lo que hacen las flechas: llevar el carril hasta dejar entera
               la primera pestaña que asomaba por ese lado.

   Si este guion no llega a ejecutarse, la página sigue siendo legible: el
   Liquid escribe hidden en todos los paneles menos el primero y el CSS
   remata lo mismo con .ml-pes__body:not(.is-listo). Lo que añade el guion
   es poder cambiar de panel. */
(function () {
  "use strict";

  function lista(n) { return Array.prototype.slice.call(n || []); }

  function suave() {
    var mm = window.matchMedia;
    return mm && mm("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
  }

  function correa() {
    var atados = [];
    var atar = function (el, ev, fn, op) {
      el.addEventListener(ev, fn, op);
      atados.push(function () { el.removeEventListener(ev, fn, op); });
    };
    atar.soltar = function () { while (atados.length) atados.pop()(); };
    return atar;
  }

  function iniciar(caja) {
    if (caja.mlIniciado) return;
    caja.mlIniciado = true;

    var marco = caja.querySelector("[data-ml-pes-caja]");
    var carril = caja.querySelector("[data-ml-pes-carril]");
    var antes = caja.querySelector("[data-ml-pes-antes]");
    var despues = caja.querySelector("[data-ml-pes-despues]");
    var cuerpo = caja.querySelector("[data-ml-pes-body]");
    var tabs = lista(caja.querySelectorAll('[role="tab"]'));
    var paneles = lista(caja.querySelectorAll("[data-ml-pes-panel]"));
    if (!tabs.length || tabs.length !== paneles.length) return;

    var cabeceras = paneles.map(function (p) { return p.querySelector("[data-ml-pes-acc]"); });
    var cuerpos = paneles.map(function (p) { return p.querySelector("[data-ml-pes-in]"); });
    var ancha = window.matchMedia("(min-width: 761px)");
    var atar = correa();
    var activo = 0;
    var espera = null;

    /* A partir de aquí manda el atributo hidden y no el display del CSS. */
    if (cuerpo) cuerpo.classList.add("is-listo");

    function desborda() {
      return !!carril && carril.clientWidth > 0 && (carril.scrollWidth - carril.clientWidth) > 1;
    }

    function bordes() {
      if (!marco || !carril) return;
      var hay = desborda();
      var max = carril.scrollWidth - carril.clientWidth;
      var x = carril.scrollLeft;
      var izq = hay && x > 1;
      var der = hay && x < max - 1;
      marco.classList.toggle("is-scroll", hay);
      marco.classList.toggle("is-izq", izq);   /* queda algo a la izquierda */
      marco.classList.toggle("is-der", der);   /* queda algo a la derecha */
      if (antes) antes.disabled = !izq;
      if (despues) despues.disabled = !der;
    }

    function ver(i) {
      var t = tabs[i];
      if (!t || !desborda() || !t.scrollIntoView) return;
      t.scrollIntoView({ behavior: suave(), block: "nearest", inline: "nearest" });
    }

    function paso(d) {
      if (!desborda()) return;
      var x = carril.scrollLeft;
      var w = carril.clientWidth;
      var destino = null;
      var i, a, b;
      for (i = 0; i < tabs.length; i++) {
        a = tabs[i].offsetLeft;
        b = a + tabs[i].offsetWidth;
        if (d > 0) {
          if (b > x + w + 1) { destino = b - w; break; }
        } else if (a < x - 1) {
          destino = a;
        }
      }
      if (destino === null) destino = x + d * w * 0.8;
      carril.scrollTo({ left: destino, behavior: suave() });
    }

    function pintar() {
      var esAncha = ancha.matches;
      tabs.forEach(function (t, i) {
        var on = i === activo;
        t.setAttribute("aria-selected", on ? "true" : "false");
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle("is-on", on);
        if (paneles[i]) paneles[i].hidden = esAncha ? !on : false;
        if (cabeceras[i]) cabeceras[i].setAttribute("aria-expanded", (esAncha || on) ? "true" : "false");
        if (cuerpos[i]) cuerpos[i].hidden = esAncha ? false : !on;
      });
    }

    /* AL CAMBIAR DE PESTAÑA NO SE MUEVE NADA. Es la regla entera.

       Los paneles no miden lo mismo, así que al cambiar de panel el
       documento cambia de alto y la página se va bajo los pies de quien
       lee. Esto lo deshace: se apunta dónde está el módulo, se repinta y se
       devuelve el módulo a donde estaba. La pestaña cambia y la vista se
       queda exactamente igual.

       AQUÍ HUBO UNA SEGUNDA MITAD Y ESTORBABA. La versión anterior, además
       de deshacer el empujón, arrastraba el borde superior del módulo hasta
       la línea de la barra pegajosa, con la idea de «aterrizar siempre al
       principio del panel nuevo». Sobre el papel suena razonable; en la
       mano es un salto cada vez que se toca una pestaña, que es justo lo
       que se venía a quitar. Y no hacía falta: la barra es pegajosa, así
       que las siete pestañas siguen a la vista se lea donde se lea.

       Con ella se fue topePegajoso(), que solo servía para eso. */

    /* QUIEN SE DESPLAZA NO ES SIEMPRE LA VENTANA, y aquí no lo es.
       En Horizon el documento está quieto —html y body llevan
       overflow:hidden— y quien se desplaza es un contenedor, .page-wrapper.
       Con window.scrollBy no se movía nada: la corrección de quieto() se
       ejecutaba entera y no corregía, y el módulo se quedaba donde lo
       hubiera dejado el recorte del navegador. En la maqueta suelta sí funcionaba, porque
       allí la ventana es la que se desplaza; de ahí que el fallo solo
       apareciera en la tienda.

       Se busca el primer ancestro que de verdad se desplace y, si no hay
       ninguno, se usa la ventana. Se calcula en cada llamada y no se
       guarda: un cambio de ancho puede cambiar quién desborda. */
    function elScroller() {
      var n = caja.parentElement;
      while (n && n !== document.body && n !== document.documentElement) {
        var e = window.getComputedStyle(n);
        if (/(auto|scroll|overlay)/.test(e.overflowY) && n.scrollHeight > n.clientHeight + 1) return n;
        n = n.parentElement;
      }
      return null;
    }

    /* Y SIEMPRE INSTANTÁNEO, con behavior "instant" escrito a mano.
       El contenedor que se desplaza lleva scroll-behavior:smooth en el CSS
       del tema, así que un scrollTop += se convertía en una animación: la
       corrección de quieto() salía tarde, se solapaba con la siguiente y
       acababa sin moverse nada.

       Y NO VALE "auto", que es el error fácil: en la especificación "auto"
       significa «haz lo que diga el CSS», o sea, seguir siendo suave. El
       valor que fuerza el salto seco es "instant". Aquí no se quiere un
       viaje: se quiere que la página esté donde tiene que estar antes de
       que el ojo lo note. */
    function desplazar(dy) {
      if (!dy) return;
      var s = elScroller();
      var destino = s || window;
      try {
        destino.scrollBy({ top: dy, behavior: "instant" });
      } catch (e) {
        if (s) { s.scrollTop += dy; } else { window.scrollBy(0, dy); }
      }
    }

    /* «antes» es dónde estaba el módulo ANTES de repintar. Si el panel
       nuevo es más corto que el que había —«Preguntas» lo es, y además es
       el último— el documento encoge, el navegador recorta el
       desplazamiento para que no sobre página por abajo y todo sube de
       golpe. Aquí se mide cuánto ha subido y se devuelve.

       Puede que el documento ya no dé de sí para devolverlo del todo: ahí
       manda el navegador y no hay nada que hacer. Pero el empujón deja de
       ser el alto entero del panel para ser, como mucho, lo que falte de
       página. */
    function quieto(antes) {
      if (antes == null) return;
      var movido = caja.getBoundingClientRect().top - antes;
      if (Math.abs(movido) > 0.5) desplazar(movido);
    }

    /* QUE NO SE PIERDA EL PRINCIPIO DE LA PESTAÑA NUEVA.

       AQUÍ HUBO UNA VEZ UN «ATERRIZA SIEMPRE ARRIBA» Y SE QUITÓ, con razón:
       arrastrar el módulo hasta la barra en CADA toque era un salto
       constante, y quien estaba leyendo el principio no necesitaba que le
       movieran nada.

       Pero al quitarlo entero se abrió el fallo contrario, y es el que
       reportó el cliente desde el móvil: si vienes leyendo el final de un
       panel largo y tocas otra pestaña, el desplazamiento se queda donde
       estaba y apareces en mitad —o al final— del panel nuevo. Hay que
       subir a buscar dónde empieza, y en una pantalla de teléfono eso es
       estar perdido.

       Los dos comportamientos son compatibles si la condición es la
       correcta: SOLO SE MUEVE SI EL PRINCIPIO NO SE VE. Estás arriba, no
       se toca nada —que es lo que se quería conservar—. Estás abajo, te
       deja el arranque del panel justo debajo de la barra, que es lo que
       falta.

       El tope se lee de la barra en vivo y no de una constante: es
       pegajosa, mide distinto según el ancho, y una cifra escrita a mano
       se queda vieja el día que cambie el relleno. Si no está pegajosa
       —anchos donde no lo es— el tope es cero y el panel sube del todo. */
    function alPrincipio(i) {
      var panel = paneles[i];
      if (!panel || !panel.getBoundingClientRect) return;

      var tope = 0;
      if (marco) {
        var pos = window.getComputedStyle(marco).position;
        if (pos === "sticky" || pos === "fixed") tope = marco.getBoundingClientRect().bottom;
      }

      var arriba = panel.getBoundingClientRect().top;
      /* Un píxel de margen: los redondeos del navegador no son un motivo
         para mover la página. */
      if (arriba >= tope - 1) return;
      desplazar(arriba - tope);
    }

    function ir(i, foco) {
      var antes = caja.getBoundingClientRect().top;
      activo = i;
      pintar();
      if (foco && tabs[i]) tabs[i].focus({ preventScroll: true });
      ver(i);
      quieto(antes);
      /* Después de quieto() y no antes: aquel deshace el recorte del
         navegador cuando el documento encoge, y si se invirtiera el orden
         se pisarían el uno al otro. */
      alPrincipio(i);
    }

    tabs.forEach(function (t, i) {
      atar(t, "click", function () { ir(i, false); });
      /* Si se llega con el tabulador, la pestaña se trae a la vista. */
      atar(t, "focus", function () { ver(i); });
      atar(t, "keydown", function (e) {
        /* Las flechas siguen el orden de lectura, que es el del DOM. En una
           sola fila no hacen falta arriba y abajo. */
        var n = tabs.length;
        var d = 0;
        if (e.key === "ArrowRight") d = 1;
        if (e.key === "ArrowLeft") d = -1;
        if (d) { e.preventDefault(); ir((i + d + n) % n, true); return; }
        if (e.key === "Home") { e.preventDefault(); ir(0, true); }
        if (e.key === "End") { e.preventDefault(); ir(n - 1, true); }
      });
    });

    if (antes) atar(antes, "click", function () { paso(-1); });
    if (despues) atar(despues, "click", function () { paso(1); });

    if (carril) {
      atar(carril, "scroll", bordes, { passive: true });
      /* La rueda del ratón no secuestra el desplazamiento vertical de la
         página: si el gesto es vertical, se lo devolvemos a la ventana. El
         gesto horizontal —trackpad o rueda inclinable— sí desplaza el
         carril. En Horizon, de 990 px para arriba, quien tiene el scroll no
         es la ventana sino .page-wrapper, así que se busca el primer
         antepasado que desplace de verdad en vez de suponer. */
      atar(carril, "wheel", function (e) {
        if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
        if (!desborda()) return;
        e.preventDefault();
        var f = e.deltaMode === 1 ? 16 : (e.deltaMode === 2 ? window.innerHeight : 1);
        /* Mismo desplazador que usa quieto(): hay un solo sitio en todo el
           guion que sabe quién se desplaza de verdad en esta página. */
        desplazar(e.deltaY * f);
      }, { passive: false });
    }

    cabeceras.forEach(function (h, i) {
      if (!h) return;
      atar(h, "click", function () {
        if (activo === i && h.getAttribute("aria-expanded") === "true") {
          h.setAttribute("aria-expanded", "false");
          if (cuerpos[i]) cuerpos[i].hidden = true;
          return;
        }
        ir(i, false);
      });
    });

    /* AQUÍ HABÍA UN ENLACE PROFUNDO que abría un panel por su ancla desde
       cualquier parte de la página. Se retira porque ningún Liquid del
       tema imprimía su atributo: era código que no llegaba a ejecutarse
       nunca, y la prueba Q19 —todo gancho del guion tiene quien lo
       imprima, y al revés— lo señala como muerto.

       Si algún día hace falta, se vuelve a escribir con las dos mitades a
       la vez: el atributo en el Liquid que lo necesite y el enlazado aquí.
       El ancla ya existe y es estable, la de cada pestaña y la de cada
       panel, así que reordenarlas en el editor no rompería el enlace. */

    function alRedimensionar() {
      window.clearTimeout(espera);
      espera = window.setTimeout(function () { pintar(); bordes(); }, 120);
    }
    atar(window, "resize", alRedimensionar);
    if (ancha.addEventListener) {
      atar(ancha, "change", function () { pintar(); bordes(); });
    } else if (ancha.addListener) {
      ancha.addListener(function () { pintar(); bordes(); });
    }

    var observador = null;
    if (window.ResizeObserver && carril) {
      observador = new ResizeObserver(bordes);
      observador.observe(carril);
    }
    /* Las pestañas miden lo que mide su rótulo, y el rótulo cambia de ancho
       cuando entra Gelasio. Hasta entonces el cálculo del desbordamiento es
       el de la tipografía de reserva. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(bordes).catch(function () {});
    }

    pintar();
    bordes();

    /* En el editor, seleccionar un bloque abre su panel. */
    caja.mlAbrirPanel = function (el) {
      var i = paneles.indexOf(el);
      if (i >= 0) ir(i, false);
    };
    caja.mlDestruir = function () {
      window.clearTimeout(espera);
      if (observador) observador.disconnect();
      atar.soltar();
    };
  }

  function cada(root, sel, fn) {
    if (root.matches && root.matches(sel)) fn(root);
    lista(root.querySelectorAll(sel)).forEach(fn);
  }

  function init(root) {
    var base = root || document;
    if (!base || !base.querySelectorAll) return;
    cada(base, "[data-ml-pes]", iniciar);
    cada(base, "[data-ml-revs]", iniciarValoraciones);
    abrirPorAncla();
  }

  /* ── VER MÁS VALORACIONES ──────────────────────────────────
     El metacampo de Judge.me trae UNA página —cinco de veinticinco—. Las
     demás se piden a su endpoint público, el mismo que usaba su propio
     widget, que devuelve EL MISMO JSON. Se pintan aquí con el marcado del
     panel, así que no vuelve a entrar ni una clase suya ni su hoja de
     estilos: eso es todo el sentido de haber quitado el widget.

     EL BOTÓN NACE OCULTO EN EL LIQUID y lo destapa esta función. Si el JS no
     carga, no hay quien traiga la página siguiente y un botón que no puede
     cumplir lo que promete es peor que no tenerlo. Se quedan las cinco
     servidas, que es lo que ve un buscador de todas formas.

     TODO TEXTO SE ESCRIBE CON textContent, nunca con innerHTML. Lo que llega
     lo escribió un cliente y viaja por una aplicación de terceros: con
     innerHTML, cualquiera que escriba una valoración mete marcado en la
     ficha. Es la misma regla que el Liquid cumple con «escape». */
  function iniciarValoraciones(caja) {
    if (caja.mlIniciado) return;
    caja.mlIniciado = true;

    var boton = caja.querySelector("[data-ml-revs-mas]");
    var lista = caja.querySelector("[data-ml-revs-lista]");
    var pie = caja.querySelector("[data-ml-revs-pie]");
    if (!boton) return;
    if (!lista) return;

    var tienda = caja.getAttribute("data-ml-revs-tienda") || "";
    var producto = caja.getAttribute("data-ml-revs-producto") || "";
    if (!tienda) return;
    if (!producto) return;

    var pagina = parseInt(caja.getAttribute("data-ml-revs-pagina"), 10) || 1;
    var por = parseInt(caja.getAttribute("data-ml-revs-por"), 10) || 5;
    var total = parseInt(caja.getAttribute("data-ml-revs-total"), 10) || 0;
    var escala = parseInt(caja.getAttribute("data-ml-revs-escala"), 10) || 5;
    var rotulo = boton.textContent;
    var cargando = false;

    boton.hidden = false;

    function pintar(r) {
      var art = document.createElement("article");
      art.className = "ml-pes__rev";

      var cab = document.createElement("div");
      cab.className = "ml-pes__rev-cab";
      if (r.reviewer_initial) {
        var ini = document.createElement("span");
        ini.className = "ml-pes__rev-ini";
        ini.setAttribute("aria-hidden", "true");
        ini.textContent = r.reviewer_initial;
        cab.appendChild(ini);
      }
      if (r.reviewer_name) {
        var by = document.createElement("span");
        by.className = "ml-pes__rev-by";
        by.textContent = r.reviewer_name;
        cab.appendChild(by);
      }
      if (r.verified_buyer) {
        var ver = document.createElement("span");
        ver.className = "ml-pes__rev-ver";
        ver.textContent = caja.getAttribute("data-ml-revs-verificada") || "";
        if (ver.textContent) cab.appendChild(ver);
      }
      if (r.created_at) {
        var f = document.createElement("time");
        f.className = "ml-pes__rev-f";
        f.setAttribute("datetime", r.created_at);
        var d = new Date(r.created_at);
        if (!isNaN(d.getTime())) {
          var dd = function (n) { return n < 10 ? "0" + n : String(n); };
          f.textContent = dd(d.getDate()) + "/" + dd(d.getMonth() + 1) + "/" + d.getFullYear();
          cab.appendChild(f);
        }
      }
      art.appendChild(cab);

      var nota = Number(r.rating);
      if (nota > 0) {
        var st = document.createElement("span");
        st.className = "ml-pes__rev-st";
        st.setAttribute("role", "img");
        var texto = "";
        for (var i = 1; i <= escala; i++) texto += i <= Math.round(nota) ? "\u2605" : "\u2606";
        st.textContent = texto;
        st.setAttribute("aria-label", nota + " / " + escala);
        art.appendChild(st);
      }

      if (r.title) {
        var t = document.createElement("h4");
        t.className = "ml-pes__rev-t";
        t.textContent = r.title;
        art.appendChild(t);
      }
      /* «body», que es texto plano, y NO «body_html». Igual que el Liquid. */
      if (r.body) {
        var b = document.createElement("p");
        b.className = "ml-pes__rev-b";
        b.textContent = r.body;
        art.appendChild(b);
      }
      lista.appendChild(art);
    }

    atarClic(boton, function () {
      if (cargando) return;
      cargando = true;
      boton.disabled = true;
      boton.textContent = caja.getAttribute("data-ml-revs-cargando") || rotulo;

      var url = "https://api.judge.me/reviews/reviews_for_widget" +
        "?shop_domain=" + encodeURIComponent(tienda) +
        "&platform=shopify" +
        "&product_id=" + encodeURIComponent(producto) +
        "&per_page=" + encodeURIComponent(por) +
        "&page=" + encodeURIComponent(pagina + 1);

      fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error("HTTP " + res.status);
          return res.json();
        })
        .then(function (datos) {
          var recibidas = (datos && datos.reviews) || [];
          recibidas.forEach(pintar);
          pagina += 1;

          var vistas = lista.querySelectorAll(".ml-pes__rev").length;
          if (pie) {
            pie.textContent = (caja.getAttribute("data-ml-revs-plantilla-pie") || "")
              .replace("__visibles__", vistas)
              .replace("__total__", total) || pie.textContent;
          }
          /* Se acabaron cuando no llega ninguna, o cuando ya se ven todas. */
          var quedan = true;
          if (recibidas.length === 0) quedan = false;
          if (vistas >= total) quedan = false;
          if (!quedan) {
            boton.remove();
            if (pie) pie.textContent = caja.getAttribute("data-ml-revs-todas") || pie.textContent;
          } else {
            boton.disabled = false;
            boton.textContent = rotulo;
          }
          cargando = false;
        })
        .catch(function () {
          /* Si falla, se dice y se deja volver a intentarlo. Callarlo dejaria
             un boton que no responde y nadie sabria por que. */
          boton.disabled = false;
          boton.textContent = caja.getAttribute("data-ml-revs-error") || rotulo;
          cargando = false;
        });
    });
  }

  function atarClic(el, fn) {
    el.addEventListener("click", fn);
  }

  /* ── LLEGAR DESDE FUERA A UNA PESTAÑA ──────────────────────
     La primera pantalla enseña la nota media y ofrece «Ver las
     valoraciones» con un enlace a #ml-valoraciones. Sin esto el enlace
     baja hasta el modulo de pestañas y deja al cliente mirando la primera,
     que es «El problema»: le has prometido valoraciones y le has dado otra
     cosa.

     La pestaña se busca por data-ml-pes-ancla, que lo escribe el Liquid, y
     no por el tipo de bloque ni por su posicion: los rotulos los cambia el
     comerciante y el orden tambien.

     SIN JAVASCRIPT EL ENLACE SIGUE SIRVIENDO. El ancla es el propio boton
     de la pestaña, que esta en el HTML servido, asi que el navegador baja
     igual hasta el modulo. Lo que se pierde es que la pestaña se abra, y
     eso es degradar, no romper. */
  function abrirPorAncla() {
    var hash = String(window.location.hash || "").replace(/^#/, "");
    if (!hash) return;
    var tab = document.querySelector('[data-ml-pes-ancla="' + hash + '"]');
    if (!tab) return;
    if (typeof tab.click === "function") tab.click();
    /* scrollIntoView y no window.scrollTo: de 990 px para arriba Horizon
       deja html y body en 100dvh con overflow hidden y el scroll lo tiene
       .page-wrapper. Es el mismo motivo que en assets/ml-producto.js. */
    var caja = tab.closest ? tab.closest("[data-ml-pes]") : null;
    if (caja && typeof caja.scrollIntoView === "function") {
      caja.scrollIntoView({ behavior: suave(), block: "start" });
    }
  }

  /* Y tambien cuando el hash cambia sin recargar, que es lo que pasa al
     pulsar el enlace de la primera pantalla estando ya en la ficha. */
  window.addEventListener("hashchange", abrirPorAncla);

  function destruir(root) {
    if (!root || !root.querySelectorAll) return;
    cada(root, "[data-ml-pes]", function (el) {
      if (typeof el.mlDestruir === "function") el.mlDestruir();
      el.mlIniciado = false;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (e) { init(e.target || document); });
  document.addEventListener("shopify:section:unload", function (e) { destruir(e.target); });

  document.addEventListener("shopify:block:select", function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var panel = el.closest("[data-ml-pes-panel]");
    var caja = el.closest("[data-ml-pes]");
    if (panel && caja && typeof caja.mlAbrirPanel === "function") caja.mlAbrirPanel(panel);
  });

  window.MLPestanas = { init: init, destroy: destruir };
})();
